import { useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

// Simple, fast client-side password validation with HIBP leak check via Edge Function
export function usePasswordValidation() {
  const [errors, setErrors] = useState<string[]>([]);

  const validatePassword = useCallback(async (password: string) => {
    const localErrors: string[] = [];

    // Strength rules (adjust as needed)
    if (password.length < 12) localErrors.push('Password must be at least 12 characters long');
    if (!/[A-Z]/.test(password)) localErrors.push('Include at least one uppercase letter');
    if (!/[a-z]/.test(password)) localErrors.push('Include at least one lowercase letter');
    if (!/[0-9]/.test(password)) localErrors.push('Include at least one number');
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/?`~]/.test(password)) localErrors.push('Include at least one special character');

    // If basic checks fail, skip network call
    if (localErrors.length === 0) {
      try {
        const { data, error } = await supabase.functions.invoke('password-leak-checker', {
          body: { password },
        });
        if (!error && data?.isLeaked) {
          localErrors.push(
            data.count && data.count > 0
              ? `This password appeared in data breaches ${data.count} times`
              : 'This password appears in known data breaches'
          );
        }
      } catch (e) {
        // Network failures should not block sign-up; just skip leak feedback
      }
    }

    setErrors(localErrors);
    return localErrors.length === 0;
  }, []);

  const getErrorMessages = useCallback(() => errors, [errors]);

  return { validatePassword, getErrorMessages };
}
